module.exports = __webpack_public_path__ + "img/kindergarten-grade-en.20b7d4de.png";